// extracted by mini-css-extract-plugin
module.exports = {"spinner":"App_spinner__2S14C"};